export const loadHighContrastEmulationStylesheet = (): Promise<
  typeof import('../../../util/styles/highContrastEmulation.css')
> => import(/* webpackChunkName: "3-render-highContrastEmulation" */ '../../../util/styles/highContrastEmulation.css');
